export function naira(n) {
  return "₦" + Number(n || 0).toLocaleString("en-NG");
}

export function formatDate(isoString) {
  if (!isoString) return "";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return isoString;
  return d.toLocaleDateString("en-NG", { year: "numeric", month: "short", day: "numeric" });
}

// For live-typing currency inputs: strips everything but digits/decimal,
// then re-inserts thousands commas as the user types.
export function formatNumberInput(raw) {
  if (raw === "" || raw === null || raw === undefined) return "";
  let value = String(raw).replace(/[^\d.]/g, "");
  const parts = value.split(".");
  const intPart = parts[0].replace(/^0+(?=\d)/, "");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.length > 1 ? `${withCommas}.${parts[1]}` : withCommas;
}

// Strips commas back out before sending to the API.
export function unformatNumberInput(formatted) {
  if (!formatted) return "";
  return String(formatted).replace(/,/g, "");
}

// Strips anything that isn't a digit, space, +, -, or parentheses —
// blocks letters in phone number fields while typing.
export function sanitizePhoneInput(raw) {
  if (!raw) return "";
  return String(raw).replace(/[^\d+\-()\s]/g, "");
}